/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hub_NoInputs */

const en_hub_no = /** @type {(inputs: Hub_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not applicable`)
};

const id_hub_no = /** @type {(inputs: Hub_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak berlaku`)
};

/**
* | output |
* | --- |
* | "Not applicable" |
*
* @param {Hub_NoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const hub_no = /** @type {((inputs?: Hub_NoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hub_NoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_hub_no(inputs)
	return en_hub_no(inputs)
});